import React, { useEffect, useState } from 'react';
import useFetchSpecialityServices from '../../Hooks/useFetchSpecialityServices';
import Radioaizer from 'Global/Components/CommonComponents/Radioaizer/Radioaizer';
import { Button, LinearProgress } from '@mui/material';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { useAtom } from 'jotai';
import { selectedSpecialityServiceAtom } from '../../shared/selected.speciality.service';

const ServiceSpeciality = ({ specialityService,setSteps }) => {
  // const specialityService = useFetchSpecialityServices();
  const [selectedSpecialityService, setSpecialityService] =
    useAtom(selectedSpecialityServiceAtom);

  useEffect(() => {
    setSpecialityService();
  }, []);


  useEffect(()=>{


    if(specialityService?.length === 1){
      setSpecialityService(specialityService[0]);
      setSteps(steps=>steps+1)

    }

  },[specialityService])

  const SpecialityServiceButton = (props) => {
    return (
      <Button
        variant="contained"
        fullWidth
        sx={{
          minHeight: '3.125em',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
          userSelect: 'none',
          color:
            props.specialityService?.id ===
            selectedSpecialityService?.id
              ? `${themeColors.ColorSecondary} !important`
              : `${themeColors.ColorPrimary} !important`,

          backgroundColor:
            props.specialityService?.id ===
            selectedSpecialityService?.id
              ? `${themeColors.ColorPrimary} !important`
              : `${themeColors.ColorSecondary} !important`,
        }}
      >
        <p>
          {ArabicToPersian(props.specialityService.label)}
        </p>
      </Button>
    );
  };

  return (
    <React.Fragment>
      {!specialityService ? (
        <LinearProgress />
      ) : (
        <Radioaizer
          direction="column"
          elements={specialityService?.map(
            (specialityService) => (
              <SpecialityServiceButton
                specialityService={specialityService}
              />
            )
          )}
          onSelectFunction={(index) => {
            setSpecialityService(specialityService[index]);
          }}
          justPassSelect={true}
        />
      )}
    </React.Fragment>
  );
};

export default ServiceSpeciality;
